import React from "react";
import {
  INewsfeedPageProps,
  ICustomerPageState,
} from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";
import AddUpdateNewsfeedPage from "./AddUpdateNewsfeedPage";
import NewsfeedList from "./NewsfeedList";

export default class NewsfeedsPage extends React.Component<
  INewsfeedPageProps,
  ICustomerPageState
> {
  constructor(props: INewsfeedPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedNewsfeed: null,
      isNewsfeedAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
      selectedCity: "",
      currentLocation: "",
    };
  }

  renderAddUpdateNewsfeedPage = () => {
    const { isEdit, selectedNewsfeed } = this.state;
    const {
      isLoading,
      isError,
      error,
      createNewsfeed,
      updateNewsfeed,
      isNewsfeedAdded,
      isNewsfeedUpdated,
    } = this.props;
    const { selectedCity } = this.state;

    return (
      <AddUpdateNewsfeedPage
        {...this.props}
        selectedNewsfeedItem={selectedNewsfeed}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        createNewsfeed={createNewsfeed}
        updateNewsfeed={updateNewsfeed}
        isNewsfeedAdded={isNewsfeedAdded}
        isNewsfeedUpdated={isNewsfeedUpdated}
      />
    );
  };

  renderNewsfeedListing = () => {
    let props: any;
    const {
      newsfeedListFetched,
      isFetchNewsfeedError,
      isNewsfeedListFetched,
      error,
      pagination,
      isNewsfeedAdded,
      isNewsfeedUpdated,
      getNewsfeedList,
      citiesList,
      fetchCities,
      isCityListFetched,
    } = this.props;
    const {
      isNewsfeedAddUpdate,
      searchText,
      currentListPosition,
      selectedCity,
      currentLocation,
    } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Newsfeed" isMainHeading={true} />
        </section>
        <NewsfeedList
          getNewsfeedList={getNewsfeedList}
          newsfeedListFetched={newsfeedListFetched}
          pagination={pagination}
          isLoading={isNewsfeedListFetched}
          isError={isFetchNewsfeedError}
          error={error}
          isNewsfeedAddedorUpdated={isNewsfeedAddUpdate}
          currentLocation={currentLocation}
          isNewsfeedAdded={isNewsfeedAdded}
          isNewsfeedUpdated={isNewsfeedUpdated}
          addUpdatePageHandler={this.toggleAddUpdateNewsfeedsPage}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
          selectedCity={selectedCity}
          citiesList={citiesList}
          fetchCities={fetchCities}
          isCityListFetched={isCityListFetched}
          {...props}
        />
      </>
    );
  };

  toggleAddUpdateNewsfeedsPage = (
    selectedCity: object = {},
    isEdit: boolean = false,
    selectedNewsfeed: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedNewsfeed: selectedNewsfeed,
      searchText: searchText,
      currentListPosition: currentScroll,
      selectedCity: selectedCity,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean, currentLocation: any) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isNewsfeedAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
      currentLocation: currentLocation,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateNewsfeedPage()
          : this.renderNewsfeedListing()}
      </div>
    );
  }
}
